// extracted by mini-css-extract-plugin
module.exports = {"btn":"Rr80mDoA7ETb2_fFUTWSg","icon":"_1S3FZbkwd4QVYFkyc92HTd"};